import { useLocale } from '../../hooks/useLocale';
import { useSettings } from '../../services/settings.api';

const AllRightsReserved = () => {
	const { t } = useLocale('client.footer');
	const { t: tGeneric } = useLocale('generic');
	const { data: settings } = useSettings();

	return (
		<p>
			© {new Date().getFullYear()} {settings?.name} -
			{t('boutiquePlants')}. {tGeneric('allRightsReserved')}.
		</p>
	);
};

export default AllRightsReserved;
